import { pushRoute } from '../../lib/router.js';
import React from 'react';
import ProjectFilesSearchContainer from '../../containers/projects/ProjectFilesSearchContainer.jsx';
import { getOrgTermsContent } from '../../content/utils.js';
import InitiativeHeader from '../headers/PageHeaders/Initiative/InitiativeHeader.jsx';
import FileTable from '../files/FileTable.jsx';
import Empty from '../Empty.jsx';
import {
  initiativeLinkedFilesContent,
  loadingContent,
} from '../EmptyStates.jsx';

const InitiativeFiles = ({
  loading,
  initiative,
  files,
  project,
  isSearching,
}) => {
  const fileCount = files?.length || 0;

  const navigateToNewFile = () => {
    if (project.archived) {
      window.alert(getOrgTermsContent('archivedProjectMessage'));
    } else {
      pushRoute('files/new', {
        projectId: initiative.project.id,
        initiativeProjectId: initiative.project.id,
        initiativeType: initiative.type,
        initiativeId: initiative.id,
      });
    }
  };

  const renderHeader = () => {
    if (!initiative?.project) return null;

    return (
      <React.Fragment>
        <InitiativeHeader initiative={initiative} hideSubHeader />

        <ProjectFilesSearchContainer
          count={fileCount}
          project={project}
          projectId={initiative.project.id}
          initiativeId={initiative.id}
          initiativeType={initiative.type}
          initiativeProjectId={initiative.project.id}
          initiative={initiative}
          navigateToNewFile={navigateToNewFile}
        />
      </React.Fragment>
    );
  };

  const renderFiles = () => {
    if (loading) return <Empty simplified content={loadingContent} />;

    if (fileCount > 0) {
      return (
        <FileTable
          files={files}
          initiativeType={initiative.type}
          archived={initiative.project.archived}
          manageProjectEntities={
            initiative.project[
              `manage${initiative.type.charAt(0).toUpperCase() + initiative.type.slice(1)}Initiatives`
            ]
          }
        />
      );
    }

    if (isSearching) return null;

    return (
      <Empty
        content={initiativeLinkedFilesContent}
        action={navigateToNewFile}
        actionAuthorization={{
          action: initiative.project[
            `manage${initiative.type.charAt(0).toUpperCase() + initiative.type.slice(1)}Initiatives`
          ]
            ? 'create'
            : '',
          subject: `${initiative.type}Initiative`,
        }}
        addBtn
      ></Empty>
    );
  };

  return (
    <React.Fragment>
      {renderHeader()}
      {renderFiles()}
    </React.Fragment>
  );
};

export default InitiativeFiles;
